import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './WorkflowTask.scss'
import HrbTranslate from '../../language/HrbTranslate';
import { Close } from '@mui/icons-material';
import DefaultModal from '../modal/DefaultModal';
import WorkflowStatusIcon from './WorkflowStatusIcon';
import Button from '../buttons/Button';

const WorkflowTaskModal = (props) => {
    const [inProgress, setInProgress] = useState(false);
     
    const onConfirm = (_) => {
        setInProgress(true);
        props.onConfirm(props.action);
    }
 
    const handleCancel = (e) => {
        setInProgress(false);
        props.onCancel(props.action);
    }

    useEffect(() => {
        setInProgress(false)
    }, [props.isOpen])

    return (
        <DefaultModal isOpen={props.isOpen}>
            <div className='workflow-modal'>
                <div className='header'>
                    <div className='header-title'>
                        <WorkflowStatusIcon status='InProgress' />
                        <h4><HrbTranslate text={props.titleKey} /></h4>
                    </div>
                    <Close className='close-btn' onClick={handleCancel}/>
                </div>                
                <div className='content'>
                    <div>
                        {props.showWarning !== false && <p className='p2 error-text'><HrbTranslate text='App.Warning' /></p>}
                        {props.contentKeys.map((k, n) => (
                            <Fragment key={`workflow-task-modal-content-${n}`}>
                                <p className='p2'><HrbTranslate text={k} /></p>
                            </Fragment>
                        ))}
                    </div>
                    <div className='button-holder'>
                            <Button
                                elementId='modal-primary-btn'
                                labelKey={props.primaryButtonKey}
                                buttonStyles='secondary'
                                onClick={onConfirm}
                                loading={inProgress} />
                            <Button
                                elementId='modal-cancel-btn'
                                labelKey='App.Cancel'
                                buttonStyles='tertiary'
                                onClick={handleCancel} />
                        </div>
                </div>
            </div>
        </DefaultModal>
    );
}

WorkflowTaskModal.whyDidYouRender = false;

WorkflowTaskModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func.isRequired,
    titleKey: PropTypes.string.isRequired,
    contentKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
    primaryButtonKey: PropTypes.string.isRequired,
    action: PropTypes.object,
    showWarning: PropTypes.bool
}

export default WorkflowTaskModal